import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportsView from '../components/views/Reports';
import { withRouter } from '../helpers/withRouter';
import { addOvertimeReportData, closeModal, openModal } from '../redux/actions';
import type {
  Project, Router, SingleModalState, State, User
} from '../types';

type Props = {
  projects: Array<Project>,
  currentUser: User,
  navigate: object,
  onGetReportData: Function,
  router: Router,
  openModal: Function,
  closeModal: Function,
};

class Reports extends Component<Props> {
  render(): React.ReactNode {
    return (
      <ReportsView
        {...this.props}
      />
    );
  }
}

const mapStateToProps = (state: State) => ({
  projects: state.projectsDropdown,
  currentUser: state.currentUser,
});

const mapDispatchToProps = dispatch => ({
  onGetReportData: () => dispatch(addOvertimeReportData()),
  openModal: (modal: SingleModalState) => dispatch(openModal(modal)),
  closeModal: (modal: SingleModalState) => dispatch(closeModal(modal)),
});

const ConnectedReports = withRouter(connect(mapStateToProps, mapDispatchToProps)(Reports as any));

export default ConnectedReports;
